import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { Grid } from "react-bootstrap";
import Header from "./components/Header";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./components/Login";
import Logout from "./components/Logout";
import RunsheetList from "./components/runsheets/list/RunsheetList";
import RunsheetView from "./components/runsheets/RunsheetView";
import RunsheetCreate from "./components/runsheets/RunsheetCreate";
import RunsheetCopy from "./components/runsheets/RunsheetCopy";
import RunsheetEdit from "./components/runsheets/RunsheetEdit";
import JobView from "./components/jobs/JobView";
import RemoteSignIn from "./components/RemoteSignIn";
import NoMatch from "./components/NoMatch";
import "./App.css";

const App = () => (
  <div className="app">
    <Grid fluid>
      <Header />
      <Switch>
        <PrivateRoute exact path="/runsheets" component={RunsheetList} />
        <PrivateRoute exact path="/runsheets/new" component={RunsheetCreate} />
        <PrivateRoute exact path="/runsheets/:id" component={RunsheetView} />
        <PrivateRoute
          exact
          path="/runsheets/:id/copy"
          component={RunsheetCopy}
        />
        <PrivateRoute
          exact
          path="/runsheets/:id/edit"
          component={RunsheetEdit}
        />
        <PrivateRoute
          exact
          path="/runsheets/:runsheetId/jobs/:jobId"
          component={JobView}
        />

        <Route path="/login" component={Login} />
        <Route path="/logout" component={Logout} />
        <Route path="/signin" component={RemoteSignIn} />

        <Route exact path="/" render={() => <Redirect to="/runsheets" />} />

        <Route component={NoMatch} />
      </Switch>
    </Grid>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js